import { useEffect } from 'react';
import { format } from 'date-fns';
import I18n from 'i18n-js';
import { func, string } from 'prop-types';

import { useTimer } from '@lootboy/lib/hooks';

import style from './AppropriateCountdown.module.scss';

const Countdown = ({ date, labelId, onEnd }) => {
  const { ended, ...data } = useTimer(date, { normalize: true });

  useEffect(() => {
    if (ended && typeof onEnd === 'function') {
      onEnd();
    }
  }, [ended, onEnd]);

  if (ended) {
    return null;
  }

  return (
    <div className={style.countdown}>
      <p>
        {I18n.t(labelId, {
          date: format(new Date(date), 'PPP'),
        })}
      </p>
      <div>
        {Object.entries(data).map(([timeUnits, value]) => (
          <div
            key={timeUnits}
            className={timeUnits}
          >
            <span>
              <span>{value}</span>
              <span>{I18n.t(`LootCountDownView_${timeUnits}`)}</span>
            </span>
            <span>
              &nbsp;
              {':'}
              &nbsp;
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

Countdown.propTypes = {
  date: string,
  labelId: string,
  onEnd: func,
};

export default Countdown;
